import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../../utils/matomoAnalytics";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top immediately when route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    setTimeout(() => {
      trackPageView();
    }, 100);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
